<template>
  <section>
    <div class="uk-text-left uk-padding">
      <section class="section-titles">
        <h3 class="title">
          Costos Financieros y Administrativos importacion
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="financialCostsImport.isExchangeRateVariationCosts"
                class="uk-checkbox"
                type="checkbox"
              > Costos por Variación en Tasa de Cambio
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="financialCostsImport.isFinancingTransportOperation"
                class="uk-checkbox"
                type="checkbox"
              > Financiación Operación de Transporte
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="financialCostsImport.isCommissionBrokers"
                class="uk-checkbox"
                type="checkbox"
              > Emision Cartas de Credito / Fianzas
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="financialCostsImport.isBankOperationRate"
                class="uk-checkbox"
                type="checkbox"
              > Tasa de Operación Bancaria
            </label>
          </div>

          <hr>

          <div class="uk-flex">
            <div class="uk-margin">
              <h4>Penalizaciones por Demora</h4>
              <label>Días de Demora estimado
              </label><br>
              <input
                v-model="financialCostsImport.estimatedDaysDelay"
                type="number"
                class=" uk-input"
                min="0"
                max="9999999"
                style="width: 35%;"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
            </div>
            <div class="uk-margin-left">
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="financialCostsImport.isContainerDelayPenalty"
                    class="uk-checkbox"
                    type="checkbox"
                  > Penalizacion por Demora en Contenedor
                </label>
              </div>
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="financialCostsImport.isCreditLettersIssuance"
                    class="uk-checkbox"
                    type="checkbox"
                  > Emisión Cartas de Crédito / Fianzas
                </label>
              </div>
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="financialCostsImport.isChassisDeliveryDelayPenalty"
                    class="uk-checkbox"
                    type="checkbox"
                  > Penalizacion por Demora Entrega Chasis
                </label>
              </div>
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="financialCostsImport.isAdditionalPrivateSecurityHiring"
                    class="uk-checkbox"
                    type="checkbox"
                  > Contratacion Seguridad Privada Adicional (Para carga de alto valor)
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      financialCostsImport: {
        isExchangeRateVariationCosts: null,
        isFinancingTransportOperation: null,
        isCommissionBrokers: null,
        isBankOperationRate: null,
        isCreditLettersIssuance: null,
        estimatedDaysDelay: null,
        isContainerDelayPenalty: null,
        isChassisDeliveryDelayPenalty: null,
        isAdditionalPrivateSecurityHiring: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'financialAndAdministrativeCostsStore'
    ])
  },
  watch: {
    financialCostsImport: {
      handler: function (newVal) {
        this.$store.commit('setFinancialAndAdministrativeCosts', newVal)
      },
      deep: true
    }
  },

  mounted () {
    this.financialCostsImport = { ...this.financialAndAdministrativeCostsStore }
  }

}
</script>

<style scoped>
p {

  margin: 10px;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  padding: 10px;
  width: 98%;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;

}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}

.items{
  margin-bottom: 20px ;
}

@media screen and (max-width: 879px){

  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
  section{
    padding: 0px 8px 20px;
  }
}
</style>
